import config from "lib/fr-config";

const ItemCategory = (() => {
  const getCategoryObj = name => {
    const treeTraversal = (tree, name) => {
      if (!tree) return null;

      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];

        if (name === node.name) {
          return { node: node, step: name === "root" ? [] : [name] };
        } else {
          const childArray = treeTraversal(node.child, name);
          if (childArray)
            return {
              node: childArray.node,
              step:
                node.name === "root"
                  ? childArray.step
                  : [node.name].concat(childArray.step)
            };
        }
      }

      return null;
    };
    const tree = config.itemCategoryTree;
    const returnObj = treeTraversal(tree, name);
    if (!returnObj) throw Error(`wrong category => category:"${name}"`);
    return returnObj;
  };

  return {
    getParentStepList: name => {
      return getCategoryObj(name).step;
    },

    getChildrenList: name => {
      const subTree = getCategoryObj(name).node;
      const subNodeArr = subTree.child || [];
      return subNodeArr.map(subNode => subNode.name);
    },
    getCategoryOrder: name => {
      const orderList = config.itemOrderList;
      const order = orderList.indexOf(name);
      if (order === -1) {
        throw Error(`null category order => category:"${name}"`);
      }
      return order;
    }
  };
})();

export default ItemCategory;
